import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function AzureTenantIdField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Tenant ID cannot be blank.');
    } else if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(newValue)) {
      setError('Tenant ID must be a valid UUID format (e.g., xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Tenant ID'
          id='tenant-id'
          aria-describedby='tenant-id-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={error}
          value={value}
        />
        {error ? (
          <FormHelperText id='tenant-id-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='tenant-id-helper-text'>
            Enter the Azure Tenant ID
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

